import React, {Component} from 'react';
import routes from "../../helpers/exportRoutes";
import {title} from "../../helpers/exportConsts";
import './Header.scss'
import icon from './resources/icon.png'
export default class Header extends Component {
  render() {
    return(

        <nav className="navbar navbar-light">
            <a className="navbar-brand" href={routes.landing}>
              <img src={icon} className="icon d-inline-block align-top" alt="logo" />
              {title('2.5rem')}
            </a>
          <div className={'row px-2 py-3 justify-content-center'}>
            <a href={routes.game} className={'mr-3'}><h5>new game</h5></a>
            <a href={routes.dev}><h5>developers</h5></a>
          </div>
        </nav>
    )
  }
}


